package gr.tech.meetinggenie.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaGoogle
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import gr.tech.meetinggenie.components.layouts.AuthPageLayout
import gr.tech.meetinggenie.styles.GoogleSignInButtonStyle
import gr.tech.meetinggenie.styles.GoogleSignInIconStyle
import gr.tech.meetinggenie.styles.LoginCardStyle
import gr.tech.meetinggenie.styles.LoginPageStyle
import gr.tech.meetinggenie.styles.LoginTitleStyle
import gr.tech.meetinggenie.util.BACKEND
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

@Page(routeOverride = "login")
@Composable
fun UserLoginPage() {
    AuthPageLayout(
        title = "Login",
        redirectIfLoggedIn = "/projects",
        requiredRoles = emptyList()
    ) {
        UserLoginScreen()
    }
}

@Composable
fun UserLoginScreen() {
    val scope = rememberCoroutineScope()
    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()

    Box(
        modifier = LoginPageStyle.toModifier().fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = LoginCardStyle.toModifier()
                .width(450.px)
                .padding(25.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            H1(LoginTitleStyle.toModifier().toAttrs()) { Text("Sign In") }

            HorizontalDivider()

            Button(
                colorPalette = null,
                modifier = GoogleSignInButtonStyle.toModifier(),
                onClick = {
                    window.location.href = "${BACKEND.BACKEND_URL}${BACKEND.ROUTES.USER_OAUTH_LOGIN}"
                }
            ) {
                FaGoogle(
                    modifier = GoogleSignInIconStyle.toModifier(),
                    size = IconSize.XL
                )
                SpanText(text = "Google Provider")
            }
        }
    }
}
